import styled from "styled-components";
import AntProgress from "antd/es/progress";
import { hexToRGB } from "@shared/utils/misc";

const Progress = styled(AntProgress)`
  .ant-progress-indicator {
    color: ${(p) => p.theme.colors.primaryText};
  }
  .ant-progress-rail {
    background-color: ${(p) => hexToRGB(p.theme.colors.textColor, 0.04)};
  }
`;

export default Progress;
